import React, { useState } from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import _ from "lodash";

const IntangibleAssetBalanceTable = ({ printMode = false }) => {
  const { list, total_balance, loading } = useSelector(
    (state) => state.intangibleAssetBalance
  );
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Account Name", dataIndex: "acc_name" },
    { title: "Opening Balance", dataIndex: "opening_balance", align: "right" },
    { title: "Asset Amount", dataIndex: "payment_total", align: "right" },
    { title: "Amortization / Disposal", dataIndex: "received_total", align: "right" },
    { title: "Net Book Value", dataIndex: "balance", align: "right" },
  ];

  return (
    <Table
      rowKey={(_, idx) => idx}
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={(p) => setPagination(p)}
      bordered
      scroll={printMode ? undefined : { x: "max-content" }}
      summary={() => {
        if (!list.length) return null;
        return (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={2} align="right">
              Grand Total:
            </Table.Summary.Cell>
            <Table.Summary.Cell index={2} align="right">
              {_.sumBy(list, (acc) => Number(acc.opening_balance)).toFixed(2)}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={3} align="right">
              {_.sumBy(list, (acc) => Number(acc.payment_total)).toFixed(2)}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={4} align="right">
              {_.sumBy(list, (acc) => Number(acc.received_total)).toFixed(2)}
            </Table.Summary.Cell>
            <Table.Summary.Cell index={5} align="right">
              {total_balance.toFixed(2)}
            </Table.Summary.Cell>
          </Table.Summary.Row>
        );
      }}
    />
  );
};

export default IntangibleAssetBalanceTable;